module.exports = __webpack_public_path__ + "img/3a.40e248be.jpg";